const zhCN = {
  uesrRegister: '用户注册',

  usernameTxt: '账户名',
  usernameBlank: '请输入帐户名！',
  usernameRegBlank: '用户名只能包含字母、数字、减号-、下划线_，长度在4-20字符之间!',
  passwordTxt: '密码',
  passwordBlank: '请输入 8-16 位密码，区分大小写！',

  passwordStrength: '密码强度',
  passwordLevel0: '低',
  passwordLevel1: '低',
  passwordLevel2: '中',
  passwordLevel3: '强',
  passwordTips: '请输入 8-16 位密码。请不要使用容易被猜到的密码。',
  passwordWarn: '密码强度不够！',

  repasswordTxt: '确认密码',
  repasswordBlank: '请确认密码！',
  repasswordWarn: '两次密码输入不一致！',

  unitNameTxt: '单位名称',
  unitNameBlank: '请输入单位名称！',

  mobileTxt: '绑定 11 位手机号',
  mobileBlank: '请输入正确的手机号！',

  varifyCodeTxt: '验证码',
  varifyCodeBlank: '请输入验证码！',
  varifyCodeSending: '验证码发送中...',
  varifyCodeSendSuccess: '验证码发送成功！',
  varifyCodeSendFail: '验证码发送失败！',

  protocolCheckbox: '已阅读并同意',
  protocolName: '《Smart iACC智客园区管理系统隐私协议》',
  protocolWarn: '请阅读并同意用户隐私协议',

  registerSuccess: '注册成功',
  registerSuccessBrief: '欢迎使用鱼住未来智能门禁管理系统！',
  registerFail: '注册失败！',

  varifyCodeBtn: '获取验证码',
  toLoginBtn: '使用已有账户登录',
  registerBtn: '注册'

}
const enUS = {
  uesrRegister: 'Register',

  usernameTxt: 'Username',
  usernameBlank: 'Username can\'t be blank!',
  usernameRegBlank: 'Username contains only 4 to 20 letters, digits, hyphens (-), and underscores (_)!',

  passwordTxt: 'Password',
  passwordBlank: 'Fill in 8-16 password, case sensitive!',

  passwordStrength: 'Strength',
  passwordLevel0: 'Low',
  passwordLevel1: 'Low',
  passwordLevel2: 'Medium',
  passwordLevel3: 'Advanced',
  passwordTips: 'Please enter 8-16 bit password. Don\'t use easily guessed passwords.',
  passwordWarn: 'Password strength not enough!',

  repasswordTxt: 'Confirm Password',
  repasswordBlank: 'Please confirm the password!',
  repasswordWarn: 'Two inconsistent password entries!',

  unitNameTxt: 'Organization',
  unitNameBlank: 'Organization can\'t be blank!',

  mobileTxt: 'Mobile Number',
  mobileBlank: 'Please enter the correct mobile number!',

  varifyCodeTxt: 'Verification Code',
  varifyCodeBlank: 'Verification Code can\'t be blank!',
  varifyCodeSending: 'Verification code sending...',
  varifyCodeSendSuccess: 'Send verification code successfully!',
  varifyCodeSendFail: 'Send verification code failed!',

  protocolCheckbox: 'Read and agree',
  protocolName: '《Smart iACC User Privacy Agreement》',
  protocolWarn: 'Please read and agree to the User Privacy Agreement',

  registerSuccess: 'Registration successfully',
  registerSuccessBrief: 'Welcome to live in the YZFuture intelligent access control system!',
  registerFail: 'Registration failed!',

  varifyCodeBtn: 'Get Code',
  toLoginBtn: 'To Login',
  registerBtn: 'Register'
}

export default { zhCN, enUS }
